import React from "react";

const techSkillGroups = [
	{
		label: "Frontend",
		color: "bg-primary text-white",
		skills: ["HTML", "CSS", "JavaScript", "React.js", "Bootstrap", "Tailwind"],
	},
	{
		label: "Backend",
		color: "bg-secondary text-white",
		skills: ["Node.js", "Express.js", "Python", "Java"],
	},
	{
		label: "Data & Cloud",
		color: "bg-accent text-white",
		skills: ["MongoDB", "MySQL", "AWS", "Google Cloud", "Azure", "Firebase"],
	},
	{
		label: "Tooling",
		color: "bg-soft text-primary",
		skills: ["Git", "NPM"],
	},
	{
		label: "EdTech",
		color: "bg-primary text-white",
		skills: ["Open edX", "SCORM", "Canvas", "Schoology"],
	},
];

const softSkills = [
	"Leadership & Mentorship",
	"Communication & Collaboration",
	"Cross-Cultural Competence",
	"Strategic Thinking",
	"Creative Problem Solving",
	"Feedback-Oriented Mindset",
];

export default function AboutMe() {
	return (
		<div className="flex flex-col bg-slate-50 pt-0 pb-16">
			<div className="flex-1">
				<div className="max-w-4xl mx-auto text-center px-4 md:px-0">
					<h1 className="text-4xl font-bold text-primary mb-8 mt-8">About Me</h1>

					{/* Profile */}
					<section className="mb-10 pb-10 border-b border-gray-200">
						<p className="text-gray-700 text-base leading-relaxed text-left">
							As a Senior Learning Systems Engineer at Western Governors University, I collaborate with cross-functional teams to design, build, and refine Open edX courses that serve thousands of students. I am deeply involved in aligning curriculum with real-world goals and scaling success through automation, AI integration, and rigorous quality review.
							<br />
							<br />
							Previously, I served as Head of Department at an international school, leading a team of educators and managing a student-published digital yearbook that earned national recognition. My background also includes frontend development, digital content management, and consulting for global clients.
							<br />
							<br />
							When I'm not developing courses or designing interfaces, I enjoy time with my family, photography, strategy games, and indoor climbing.
						</p>
					</section>

					{/* Tech Skills */}
					<section className="mb-10 pb-10 border-b border-gray-200 text-left">
						<h2 className="text-2xl font-semibold text-secondary mb-6 text-center">Tech Skills</h2>
						<div className="space-y-4">
							{techSkillGroups.map((group) => (
								<div key={group.label} className="flex flex-wrap items-center gap-2">
									<span className="text-xs font-bold text-gray-400 uppercase tracking-widest w-20 shrink-0">
										{group.label}
									</span>
									{group.skills.map((skill) => (
										<span
											key={skill}
											className={`${group.color} px-3 py-1 rounded-full text-sm font-medium shadow-sm`}
										>
											{skill}
										</span>
									))}
								</div>
							))}
						</div>
					</section>

					{/* Soft Skills */}
					<section className="mb-10 pb-10 border-b border-gray-200 text-left">
						<h2 className="text-2xl font-semibold text-secondary mb-6 text-center">Soft Skills</h2>
						<div className="flex flex-wrap justify-center gap-3">
							{softSkills.map((skill) => (
								<span
									key={skill}
									className="border-2 border-secondary text-secondary px-4 py-1.5 rounded-full text-sm font-medium"
								>
									{skill}
								</span>
							))}
						</div>
					</section>

					{/* Education */}
					<section className="mb-12 text-left">
						<h2 className="text-2xl font-semibold text-secondary mb-6 text-center">Education</h2>
						<ul className="space-y-4">
							{[
								{ school: "Western Governors University", degree: "B.S. Computer Science", note: "In Progress (2026)" },
								{ school: "Moreland University", degree: "M.Ed. of Education (Globalization & Research)", note: "2021" },
								{ school: "University of Tennessee", degree: "B.A. Chemistry", note: "2018" },
								{ school: "Indiana Wesleyan University", degree: "M.Ed. of Education (Curriculum and Instruction)", note: "2014" },
								{ school: "Johnson University", degree: "B.S. Communications", note: "2012" },
							].map((item) => (
								<li key={item.school} className="bg-white rounded-lg px-5 py-4 shadow-sm flex justify-between items-start flex-wrap gap-2">
									<div>
										<p className="font-semibold text-primary">{item.school}</p>
										<p className="text-gray-700 text-sm">{item.degree}</p>
									</div>
									<span className="text-xs font-medium text-gray-400 bg-gray-100 px-2 py-1 rounded mt-1 self-start">
										{item.note}
									</span>
								</li>
							))}
						</ul>
					</section>
				</div>
			</div>
		</div>
	);
}
